// Canonical site URL for SEO (canonical tags, OG, JSON-LD, sitemap refs).
// Configurable per environment; defaults to the production domain so that
// canonical/OG URLs stay correct even when served from a preview host.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://endasphere.com").replace(/\/$/, "");
